import { ShiftBottomSheetBookabilityCriteriaCard } from "./BookabilityCriteriaCard";

export function ShiftBottomSheetBookingRequestOverlapCard() {
  return (
    <ShiftBottomSheetBookabilityCriteriaCard
      title="Cannot request shift"
      description="You have overlapping shifts or pending requests for this time period."
      illustrationType="fail"
    />
  );
}
